import * as React from 'react';
import { observer } from 'mobx-react';
import { themeStore } from '@GlobalStores';
import './brand.scss';

type BrandProps = {
	className?: string;
};

@observer
export class Brand extends React.PureComponent<BrandProps> {
	render() {
		const { className } = this.props;
		const cls = className ? `${className} main-nav-brand` : 'main-nav-brand';
		const logo = themeStore.theme === 'dark' ? 'images/logo_dark.svg' : 'images/logo.png';

		return (
			<div className={cls} style={{ backgroundImage: `url("${logo}")` }}>
				{this.props.children}
			</div>
		);
	}
}
